/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import './Button.css';

export function Button({ icon, type, text }) {
  const navigate = useNavigate();

  const urlOuvidoria = 'https://www.gov.br/ebserh/pt-br/acesso-a-informacao/participacao-social/ouvidoria-geral/ouvidoria';
  const urlTermosUsoPrivacidade = 'https://www.gov.br/ebserh/pt-br/acesso-a-informacao/tratamento-de-dados-pessoais/orientacoes-e-modelos/termo-de-uso-e-aviso-de-privacidade';
  function selectLink() {
    if (type === 'faq') window.open(urlOuvidoria, '_blank');
    if (type === 'terms') window.open(urlTermosUsoPrivacidade, '_blank');
    if (type === 'questions') navigate('/questoesfrequentes');
  }
  return (
    <button
      className={`externalPageButton ${type}`}
      onClick={() => selectLink()}
    >
      {icon && (
      <FontAwesomeIcon
        icon={icon}
        size="sm"
        color="#1351b4"
        style={{ marginRight: '8px' }}
      />
      ) }
      {text}
    </button>
  );
}
